import { logger } from '../../datadog';
import { toast } from '../../toasts';
import { InSessionPatientNoteWrapper as InSessionPatientNote } from '../patient-note/PatientNoteWrapper';
import { PatientNotePopoverControlButton } from './PatientNotePopoverControlButton';

function onPatientNotePopoverError() {
  logger.error('PatientNotePopoverControlButton threw an unexpected error');
  toast.error('An unexpected error occurred while attempting to open the sticky note.');
}

export function PatientNotePopoverControlButtonWrapper() {
  return (
    <PatientNotePopoverControlButton onError={onPatientNotePopoverError} patientNoteComponent={InSessionPatientNote} />
  );
}
